<template>
  <div>
    <h5 class="package-title" v-translate>Supplements</h5>
    <b-card no-body class="border-top-0">
      <b-table-simple class="table table-sm mb-0" stacked="sm" striped>
        <thead>
          <tr>
            <td><span v-translate class="ml-4">Name</span></td>
            <td v-translate>Price</td>
            <td>&nbsp;</td>
          </tr>
        </thead>
        <tbody v-if="date.supplements.length">
          <template v-for="(supp, suppIndex) in date.supplements">
          <Supplement
            :index="suppIndex"
            :supplement="supp"
            :currency="currency"
            :checked="selection[suppIndex]"
            :pax="pax"
            @change="onElementSelectionChange($event, suppIndex)"
            :key="'supp' + suppIndex" />
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3" class="text-center">
              <translate>no supplements</translate>
            </td>
          </tr>
        </tbody>
      </b-table-simple>
    </b-card>
  </div>
</template>

<script>
import Supplement from './supplement.vue'

export default {
  props: {
    date: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    selection: {
      type: Array,
      required: true
    },
    pax: {
      type: Array,
      required: true
    }
  },
  components: {
    Supplement
  },
  methods: {
    onElementSelectionChange (value, index) {
      this.$emit('change', { value, index })
    }
  }
}
</script>
